import React from 'react';
import {Stack, Typography} from '@mui/material';

import {DataInfo} from 'presentation/components';
import {translations} from 'presentation/translations-new';
import {formatTextSlice} from 'presentation/utils';
import {OdontoSpecialtiesSection} from '../OdontoSpecialtiesSection';
import {OdontoServicesSectionProps} from './types';
import {useOdontoProviderDetailsQuery} from 'presentation/modules/guide/odonto/queries/useOdontoProviderDetailsQuery';

const {guideDetails} = translations['pt-br'].privateFlow.guideFlow;

export function OdontoServicesSection({provider}: OdontoServicesSectionProps) {
	const {codigo, uf, cidade, tipo} = provider;

	const {
		data: providerDetail,
		isError,
		isLoading: loading,
	} = useOdontoProviderDetailsQuery({
		cdPrestador: String(codigo),
		nmCidade: cidade,
		dsTipo: tipo,
		cdUf: uf,
	});

	const emptyData = !provider?.tipo && !loading && providerDetail?.especialidades.length === 0;

	return (
		<Stack gap={1}>
			<Typography variant="subtitle2" color="text.secondary">
				{guideDetails.services}
			</Typography>
			{emptyData ? (
				<Typography variant="body2" color="text.secondary">
					{guideDetails.emptyData}
				</Typography>
			) : (
				<Stack gap={1.5}>
					{provider.tipo ? (
						<DataInfo
							removeItemTextMargin
							iconName="clipboard-plus-outline"
							primaryText={guideDetails.servicesTypes}
							primaryTextColor="text.primary"
							primaryTextFontSize="1rem"
							secondaryText={formatTextSlice(provider.tipo)}
							secondaryTextColor={'text.secondary'}
							secondaryTextFontSize="0.875rem"
							removePaddingBottom
						/>
					) : null}

					<OdontoSpecialtiesSection
						data={providerDetail}
						hasError={isError}
						loading={loading}
					/>
				</Stack>
			)}
		</Stack>
	);
}
